export default function PHP_Interfaces() {
  return (
    <div>
      <h1>PHP_Interfaces</h1>
    </div>
  );
}
